import _extends from "@babel/runtime/helpers/extends";
import { makeStyles } from "../Utilities/ThemeHelper";
import classNames from "classnames";
import React from "react";
import { components } from "react-select";
const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(1),
    display: "inline-flex",
    alignItems: "center"
  },
  root: {
    display: "inline-flex"
  }
}));
export const MultiValueLabel = props => {
  const {
    innerProps,
    className,
    children,
    ...otherProps
  } = props;
  const icon = props.data.icon;
  const classes = useStyles(props);
  const combinedInnerProps = {
    className: classNames(className, "prmbl-autocomplete__multi-value", classes.root, innerProps?.className)
  };
  return /*#__PURE__*/React.createElement(components.MultiValueLabel, _extends({}, otherProps, {
    innerProps: combinedInnerProps
  }), icon ? /*#__PURE__*/React.createElement("span", {
    className: classNames(classes.icon, "prmbl-autocomplete__multi-value__label-icon")
  }, icon) : null, children);
};